module.exports = __webpack_public_path__ + "assets/img/1-3-en.c582fa46.png";